import { render, staticRenderFns } from "./xueqing.vue?vue&type=template&id=aa165af6&scoped=true&"
import script from "./xueqing.vue?vue&type=script&lang=js&"
export * from "./xueqing.vue?vue&type=script&lang=js&"
import style0 from "./xueqing.vue?vue&type=style&index=0&id=aa165af6&prod&lang=scss&"
import style1 from "./xueqing.vue?vue&type=style&index=1&id=aa165af6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa165af6",
  null
  
)

export default component.exports